import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IntegrationApp } from '@proto/integrationapp';
import { Model } from 'src/app/app.model';

@Component({
  selector: 'app-integration-apps-detail-card',
  templateUrl: './integration-apps-detail-card.component.html',
  standalone: false
})
export class IntegrationAppsDetailCardComponent {

  @Input() public integrationApp: IntegrationApp;
  @Input() public integrationAppVersion?: number;
  @Input() public integrationAppOwnerId?: number;
  @Input() public preselectedSubId?: string;
  @Input() public preselectedSubName?: string;
  @Input() public isAdmin: boolean = false;

  @Output() install: EventEmitter<{ appId: string }> = new EventEmitter<{ appId: string }>();

  private companyId: number;

  constructor(private m: Model) {
    this.companyId = +m.account.currentUser.companyId;
  }

  get isOwnApp(): boolean {
    return this.integrationAppOwnerId === this.companyId;
  }

  startInstallation(appId: string) {
    this.install.emit({ appId: appId });
  }
  
}
